import { Common } from 'src/domains/common/Common';
import { action, makeAutoObservable, observable } from 'mobx';
import { OffersContactPreferencesNewState } from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/offersSettingsNew/OffersSettingsNew.state';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { ContactPreferencesNewOptionType } from 'src_server/trpc/types/accountModel/changeAccountContactPreferencesNew';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { reportEmailConsentToOptimove } from '../reportOptimoveConsent';

export type ContactPreferencesNewStateInfoMessageType = 'success' | 'error' | null;

const createOffersContactPreferencesNewState = (): AutoMap<
    [
        email?: ContactPreferencesNewOptionType[],
        phone?: ContactPreferencesNewOptionType[],
        sms?: ContactPreferencesNewOptionType[],
    ],
    OffersContactPreferencesNewState
> =>
    new AutoMap(([email, phone, sms]) => {
        return new OffersContactPreferencesNewState(email, phone, sms);
    });

export class ContactPreferencesNewState {
    @observable public infoMessage: ContactPreferencesNewStateInfoMessageType = null;

    public readonly offersContactPreferencesNewStateAuto: AutoMap<
        [
            email?: ContactPreferencesNewOptionType[],
            phone?: ContactPreferencesNewOptionType[],
            sms?: ContactPreferencesNewOptionType[],
        ],
        OffersContactPreferencesNewState
    >;
    public constructor(private readonly common: Common) {
        this.offersContactPreferencesNewStateAuto = createOffersContactPreferencesNewState();
        makeAutoObservable(this);
    }

    @action public submitContactPreferences = async (
        id: number | null,
        email: string | null,
        offersContactPreferencesNewState: OffersContactPreferencesNewState
    ): Promise<void> => {
        this.infoMessage = null;

        if (id === null) {
            console.error('no customer id');
            this.infoMessage = 'error';
            return;
        }

        const contactPreferences = offersContactPreferencesNewState.formatFormModel.result.value;

        if (contactPreferences.type === 'error') {
            console.error('no contact preferences');
            this.infoMessage = 'error';
            return;
        }

        try {
            await this.common.trpcClient.client.accounts.changeAccountContactPreferencesNew.mutate({
                contactPreferences: contactPreferences.data.contactPreferences,
                customerId: id,
            });

            const emailPreferences = contactPreferences.data.contactPreferences.find(
                (preference) => preference.type === 'email'
            );
            const brandId = ConfigComponents.get(this.common).config.optimoveBrandId;
            reportEmailConsentToOptimove(brandId, email, (emailPreferences?.categories.length ?? 0) > 0);

            this.infoMessage = 'success';
        } catch {
            this.infoMessage = 'error';
            console.error('submitContactPreferences');
        }
    };
}
